(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery, getComputedStyle,
	gsap, ScrollTrigger, Carousel, Autoscroll, Fancybox, Lenis, Arrows */

	// Register GSAP Plugins
	gsap.registerPlugin(ScrollTrigger);

	// window.matchMedia("(max-width: 700px)")
	const documentBodyStyle = getComputedStyle(document.body);
	const mdBreakpoint = documentBodyStyle.getPropertyValue("--md-breakpoint");

	const inviewDelay = 100;

	let lazyLoadInstance;
	let lenis;
	let currentContainer = $(".js-main");
	let heroScrollTrigger;
	let processScrollTrigger;
	let footerScrollTrigger;

	let windowTop = $(window).scrollTop();
	let windowHeight = window.innerHeight;
	let windowWidth = document.documentElement.clientWidth;
	let previousWindowWidthForHeight = false;
	let previousWindowHeightForFooter = false;





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		lazyLoadInstance = new LazyLoad({
			elements_selector: ".js-lazy",
		});
	}





// Set Variables in JS
// -----------------------------------------------------------------------------

	function setScrollbarWidthVariable() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
	}

	function set100VHVariable() {
		// if (windowWidth !== previousWindowWidthForHeight) {
		// 	previousWindowWidthForHeight = windowWidth;
		// 	document.documentElement.style.setProperty("--vh", `${windowHeight}px`);
		// }
	}





// Scroll Smoother (Lenis)
// -----------------------------------------------------------------------------

	function initLenis() {
		lenis = new Lenis();

		lenis.on("scroll", ScrollTrigger.update);

		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		gsap.ticker.lagSmoothing(0);
	}

	function resizeLenis() {
		lenis.resize();
	}





// Hero ScrollTrigger
// -----------------------------------------------------------------------------

	function getOverlap(element) {
		const overlapValue = Math.min(windowHeight, element.offsetHeight);
		return overlapValue;
	}

	function adjustOverlap(element) {
		$(element).css("margin-top", `${-getOverlap(element)}px`);
	}

	function scrollMdQuery() {
		const bp = mdBreakpoint.trim().replace(/,\s*$/, "");
		return `(min-width: ${bp})`;
	}

	function isScrollMdUp() {
		return window.matchMedia(scrollMdQuery()).matches;
	}

	function initHeroScrollTrigger() {
		const hero = currentContainer.find(".js-hero-section").get(0);
		if (!hero) return;

		if (heroScrollTrigger) {
			heroScrollTrigger.kill();
			heroScrollTrigger = null;
		}

		heroScrollTrigger = gsap.to(hero, {
			ease: "none",
			scrollTrigger: {
				trigger: hero,
				start: "top top",
				end: "bottom top",
				pin: true,
				pinSpacing: false,
				anticipatePin: 0,
				invalidateOnRefresh: true,
			},
		});
	}

	function resetFooterSection(footer) {
		$(footer).css("margin-top", "");
		gsap.set(footer, { clearProps: "transform" });
	}

	function isFooterScrollPinEnabled(footer) {
		return windowHeight > footer.offsetHeight;
	}

	function initFooterScrollTrigger() {
		const footer = currentContainer.find(".js-footer-section").get(0);
		if (!footer) return;

		if (footerScrollTrigger) {
			footerScrollTrigger.kill();
			footerScrollTrigger = null;
		}

		if (!isScrollMdUp() || !isFooterScrollPinEnabled(footer)) {
			resetFooterSection(footer);
			return;
		}

		adjustOverlap(footer);

		footerScrollTrigger = gsap.to(footer, {
			ease: "none",
			scrollTrigger: {
				trigger: footer,
				start: () => `top ${windowHeight - getOverlap(footer)}`,
				end: () => `+=${getOverlap(footer)}`,
				pin: true,
				pinSpacing: true,
				anticipatePin: 0,
				invalidateOnRefresh: true,
			},
		});
	}

	function getPageScrollMax() {
		return Math.max(
			0,
			document.documentElement.scrollHeight - window.innerHeight,
		);
	}

	function scrollToPageBottom() {
		const target = getPageScrollMax();

		if (lenis) {
			lenis.scrollTo(target, { duration: 1.5 });
		} else {
			window.scrollTo({ top: target, behavior: "smooth" });
		}
	}

	function scrollToPageMain() {
		const target = $("#main").offset().top;

		if (lenis) {
			lenis.scrollTo(target, { duration: 1.5 });
		} else {
			window.scrollTo({ top: target, behavior: "smooth" });
		}
	}

	function initFooterAnchorLinks() {
		$(document).on("click", "a[href='#footer']", (event) => {
			event.preventDefault();
			scrollToPageBottom();
		});

		$(document).on("click", "a[href='#main']", (event) => {
			event.preventDefault();
			scrollToPageMain();
		});
	}




// Process section ScrollTrigger (pin + scrub left column)
// -----------------------------------------------------------------------------

	function getProcessLeftViewHeight(leftEl) {
		const cs = getComputedStyle(leftEl);
		const pt = parseFloat(cs.paddingTop) || 0;
		const pb = parseFloat(cs.paddingBottom) || 0;
		return Math.max(0, leftEl.clientHeight - pt - pb);
	}

	function resetProcessSection(container) {
		const header = container.find(".js-process-left-header").get(0);
		const inner = container.find(".js-process-left-inner").get(0);
		const images = container.find(".c-process-image").toArray();
		const texts = container.find(".c-process-text").toArray();

		if (inner) {
			gsap.set(inner, { clearProps: "transform" });
		}
		if (header) {
			gsap.set(header, { clearProps: "transform" });
		}
		setProcessStepVisuals(0, images, texts);
	}

	function getProcessScrollMetrics(trackEl, innerEl) {
		if (!trackEl || !innerEl) {
			return { scrollDistance: 0, yStart: 0, yEnd: 0 };
		}
		const viewH = getProcessLeftViewHeight(trackEl);
		const thisScrollHeight = innerEl.scrollHeight;
		const firstText = innerEl.querySelector(".c-process-text");
		const firstTextBottom = firstText
			? firstText.offsetTop + firstText.offsetHeight
			: 0;
		const yStart = viewH - firstTextBottom;
		const yEnd = viewH - thisScrollHeight;
		const scrollDistance = Math.max(0, yStart - yEnd);
		return {
			scrollDistance,
			yStart,
			yEnd,
		};
	}

	function getHeaderTrackGap(headerEl, trackEl) {
		if (!headerEl || !trackEl) return 0;
		return trackEl.offsetTop - (headerEl.offsetTop + headerEl.offsetHeight);
	}

	function updateProcessHeaderY(headerEl, trackEl, innerEl) {
		if (!headerEl || !innerEl) return;
		const firstText = innerEl.querySelector(".c-process-text");
		if (!firstText) {
			gsap.set(headerEl, { y: 0 });
			return;
		}
		const gap = trackEl ? getHeaderTrackGap(headerEl, trackEl) : 0;
		const yInner = parseFloat(gsap.getProperty(innerEl, "y")) || 0;
		const fy = firstText.offsetTop;
		const headerY = Math.min(0, gap + fy + yInner);
		gsap.set(headerEl, { y: headerY });
	}

	function setProcessStepVisuals(progress, images, texts) {
		const stepCount = texts.length || images.length;
		if (!stepCount) return;

		const idx = stepCount === 1 ? 0 : Math.round(progress * (stepCount - 1));

		if (images.length) {
			const imgIdx = images.length === 1 ? 0 : Math.min(idx, images.length - 1);
			images.forEach((img, i) => {
				img.classList.toggle(
					"is-process-image-active",
					images.length === 1 || i === imgIdx,
				);
			});
		}

		if (texts.length) {
			const textIdx = texts.length === 1 ? 0 : Math.min(idx, texts.length - 1);
			texts.forEach((block, i) => {
				block.classList.toggle("is-process-active", i === textIdx);
			});
		}
	}

	function initProcessScrollTrigger() {
		const container = currentContainer.find(".js-process-container");
		if (!container.length) return;

		const wrapper = container.get(0);
		const header = container.find(".js-process-left-header").get(0);
		const track = container.find(".js-process-left-track").get(0);
		const inner = container.find(".js-process-left-inner").get(0);
		const images = container.find(".c-process-image").toArray();
		const texts = container.find(".c-process-text").toArray();

		if (processScrollTrigger) {
			processScrollTrigger.kill();
			processScrollTrigger = null;
		}

		if (!wrapper || !track || !inner) return;

		if (!isScrollMdUp()) {
			resetProcessSection(container);
			return;
		}

		gsap.set(inner, { clearProps: "transform" });
		if (header) {
			gsap.set(header, { clearProps: "transform" });
		}

		const metrics = getProcessScrollMetrics(track, inner);
		setProcessStepVisuals(0, images, texts);

		if (metrics.scrollDistance < 1) {
			if (Math.abs(metrics.yStart) > 0.5) {
				gsap.set(inner, { y: metrics.yStart });
			} else {
				gsap.set(inner, { clearProps: "transform" });
			}
			if (header) {
				updateProcessHeaderY(header, track, inner);
			}
			return;
		}

		processScrollTrigger = gsap.fromTo(
			inner,
			{
				y: () => getProcessScrollMetrics(track, inner).yStart,
			},
			{
				y: () => getProcessScrollMetrics(track, inner).yEnd,
				ease: "none",
				scrollTrigger: {
					trigger: wrapper,
					start: "top top",
					end: () => `+=${getProcessScrollMetrics(track, inner).scrollDistance}`,
					pin: wrapper,
					pinSpacing: true,
					scrub: true,
					anticipatePin: 0,
					invalidateOnRefresh: true,
					onUpdate: (self) => {
						setProcessStepVisuals(self.progress, images, texts);
						if (header) {
							updateProcessHeaderY(header, track, inner);
						}
					},
				},
			},
		);

		if (header) {
			updateProcessHeaderY(header, track, inner);
		}
	}

	function initScrollTriggers() {
		initHeroScrollTrigger();
		initProcessScrollTrigger();
		initFooterScrollTrigger();
		ScrollTrigger.refresh();
	}





// In View
// -----------------------------------------------------------------------------

	function addInView(loadingElement, loadingIndex) {
		if (loadingElement.hasClass("is-loading")) return;

		loadingElement.addClass("is-loading");
		setTimeout(() => {
			loadingElement.addClass("is-loaded");
			loadingElement.removeClass("is-loading");

		}, inviewDelay * (loadingIndex));
	}

	function inView() {
		const loadItems = $(".js-inview:visible").not(".is-loaded, .is-loading");
		let stoppedAt = 0;

		loadItems.each(function (loadItemIndex) {
			const loadItem = $(this);
			const loadItemTop = loadItem.offset().top;

			if (windowTop + windowHeight * 1.05 > loadItemTop) {
				if (windowTop - windowHeight / 2 > loadItemTop) {
					loadItem.addClass("is-loaded");
					loadItem.removeClass("is-loading");
					stoppedAt = loadItemIndex;
					return;
				}
				addInView(loadItem, loadItemIndex - stoppedAt);
			}
		});
	}





// Resize Functions
// -----------------------------------------------------------------------------

	function resizeFunctions() {
		windowHeight = window.outerHeight;
		windowWidth = document.documentElement.clientWidth;
		console.log(windowWidth);

		lazyLoadInstance.update();
		setScrollbarWidthVariable();
		set100VHVariable();
		resizeLenis();
		const widthChanged = windowWidth !== previousWindowWidthForHeight;
		const heightChanged = windowHeight !== previousWindowHeightForFooter;

		console.log(widthChanged, heightChanged);
		console.log(windowWidth, previousWindowWidthForHeight);

		if (widthChanged) {
			previousWindowWidthForHeight = windowWidth;
			//initProcessScrollTrigger();
			ScrollTrigger.refresh();
		}
		if (widthChanged || heightChanged) {
			previousWindowHeightForFooter = windowHeight;
			//initFooterScrollTrigger();
			//ScrollTrigger.refresh();
		}
	}





// Init Carousel
// -----------------------------------------------------------------------------

	function initCarousel() {
		const container = $(".js-carousel");
		const options = {
			center: false,
			slidesPerPage: 1,
			Arrows: {

			},
			on: {
				ready: () => {
					resizeFunctions();
				},
			},
		};

		if (container.length) {
			container.each(function () {
				if ($(this).hasClass("f-carousel--autoplay")) {
					options.Autoscroll = {
						speed: 4,
						speedOnHover: 0,
					};
				} else {
					options.Autoscroll = false;
				}

				const thisContainer = $(this).get(0);
				Carousel(thisContainer, options, { Autoscroll, Arrows }).init();
			});
		}
	}




// Histoire: first paragraph + toggle for the rest
// -----------------------------------------------------------------------------

	const histoireRevealDuration = 0.55;
	const histoireRevealEase = "power2.inOut";
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	function setHistoireToggleState($btn, $labelMore, $labelLess, expanded) {
		$btn.attr("aria-expanded", expanded);
		$labelMore.prop("hidden", expanded);
		$labelLess.prop("hidden", !expanded);
	}

	function setHistoireMoreInstant($more, expanded) {
		gsap.killTweensOf($more[0]);
		$more.css({ height: "", overflow: "", opacity: "" });
		$more.prop("hidden", !expanded);
	}

	function revealHistoireMore($more, onComplete) {
		const el = $more[0];

		$more.prop("hidden", false);
		gsap.set(el, { height: 0, overflow: "hidden", opacity: 0 });

		gsap.to(el, {
			height: el.scrollHeight,
			opacity: 1,
			duration: histoireRevealDuration,
			ease: histoireRevealEase,
			onComplete: () => {
				gsap.set(el, { height: "auto", overflow: "", clearProps: "opacity" });
				ScrollTrigger.refresh();
				onComplete();
			},
		});
	}

	function hideHistoireMore($more, onComplete) {
		const el = $more[0];

		gsap.set(el, { height: el.scrollHeight, overflow: "hidden" });

		gsap.to(el, {
			height: 0,
			opacity: 0,
			duration: histoireRevealDuration * 0.85,
			ease: histoireRevealEase,
			onComplete: () => {
				$more.prop("hidden", true);
				gsap.set(el, { clearProps: "height,overflow,opacity" });
				ScrollTrigger.refresh();
				onComplete();
			},
		});
	}

	function initHistoireTextToggle() {
		$(".js-histoire-text").each(function () {
			const $root = $(this);
			const $more = $root.find(".js-histoire-text-more");
			const $btn = $root.find(".js-histoire-text-toggle");
			const $labelMore = $btn.find(".js-histoire-text-toggle-more");
			const $labelLess = $btn.find(".js-histoire-text-toggle-less");
			let isAnimating = false;

			if (!$more.length || !$btn.length) {
				return;
			}

			$btn.on("click", () => {
				if (isAnimating) {
					return;
				}

				const expanded = $btn.attr("aria-expanded") === "true";
				const next = !expanded;

				if (prefersReducedMotion) {
					setHistoireToggleState($btn, $labelMore, $labelLess, next);
					setHistoireMoreInstant($more, next);
					return;
				}

				isAnimating = true;

				const unlock = () => {
					setHistoireToggleState($btn, $labelMore, $labelLess, next);
					isAnimating = false;
				};

				if (next) {
					revealHistoireMore($more, unlock);
				} else {
					hideHistoireMore($more, unlock);
				}
			});
		});
	}



// Init Fancybox
// -----------------------------------------------------------------------------

	function initFancybox() {
		Fancybox.bind("[data-fancybox]", {
			Thumbs: false,
			Toolbar: false,
			dragToClose: false,
			closeButton: false,
			groupAttr: false,
			fadeEffect: false,
			zoomEffect: false,
			showClass: "f-zoomInUp",
			hideClass: "f-zoomOutDown",
			Panzoom: {
				panMode: false,
			},
			on: {
				"Carousel.contentReady": () => {
					const thisContainer = $(".js-single-carousel").get(0);
					lenis.stop();
					Carousel(thisContainer, {
						center: false,
						slidesPerPage: 1,
						fill: true,
						infinite: false,
						Arrows: {

						},
						on: {
							ready: () => {
								resizeFunctions();
							},
						},
					}, { Arrows }).init();
				},
				destroy: () => {
					lenis.start();
					resizeFunctions();
				},
			},
		});
	}

// Page Load Functions
// -----------------------------------------------------------------------------

	function pageReadyFunctions(container) {
		currentContainer = $(container);
		initCarousel();
		initHistoireTextToggle();
		initFancybox();
	}

	function pageLoadFunctions(container) {
		currentContainer = $(container);
		lazyLoadInstance.update();
		initScrollTriggers();
	}





// Init
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		currentContainer = $(".js-main");

		windowTop = document.documentElement.scrollTop;
		windowHeight = window.innerHeight;
		windowWidth = document.documentElement.clientWidth;
		window.history.scrollRestoration = "manual";

		initLazyLoad();
		setScrollbarWidthVariable();
		set100VHVariable();
		initLenis();
		initFooterAnchorLinks();
		pageReadyFunctions(currentContainer);
		pageLoadFunctions(currentContainer);
	});

	$(window).on("scroll", () => {
		windowTop = document.documentElement.scrollTop;

		if (!$("html").hasClass("is-loading")) {
			inView();
		}
	});

	$(window).on("resize", () => {
		resizeFunctions();
	});

}(jQuery));
